"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);
    _this.btnRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      step: "initial",
      //initial, loading, done
      clicked: false,
      hideLoadingText: false
    };
    _this.handleClickEvent = _this.handleClickEvent.bind(_assertThisInitialized(_this));
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    _this.startAnimation = _this.startAnimation.bind(_assertThisInitialized(_this));
    _this.stopAnimation = _this.stopAnimation.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.hideLoadingText = _this.hideLoadingText.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.animated) {
        this.setState({
          hideLoadingText: this.hideLoadingText()
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      this.props.onChange(event);
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(e) {
      var _this2 = this;

      var self = this;

      if (this.props.animateOnClick) {
        if (!self.state.clicked) {
          self.setState({
            clicked: true
          }, function () {
            self.props.onClick(e, _this2);
            self.startAnimation();
          });
        }
      } else {
        self.props.onClick(e, this);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        step: "initial",
        clicked: false
      });
    }
  }, {
    key: "hideLoadingText",
    value: function hideLoadingText() {
      var _this$btnRef, _this$btnRef$current, _this$btnRef$current$;

      if (((_this$btnRef = this.btnRef) === null || _this$btnRef === void 0 ? void 0 : (_this$btnRef$current = _this$btnRef.current) === null || _this$btnRef$current === void 0 ? void 0 : (_this$btnRef$current$ = _this$btnRef$current.childNodes) === null || _this$btnRef$current$ === void 0 ? void 0 : _this$btnRef$current$.length) > 3) {
        var basePxSize = window.innerWidth > 1440 ? 16 : 14;
        var spinnerPaddingAdj = {
          "big": 3 * basePxSize,
          "medium": 2 * basePxSize,
          "small": basePxSize,
          "xsmall": basePxSize
        };
        var btnLength = this.btnRef.current.offsetWidth;
        var spinnerWidth = this.btnRef.current.childNodes[4].offsetWidth + spinnerPaddingAdj[this.props.size]; // +24 is the padding of the spinner

        var loadingTextWidth = this.btnRef.current.childNodes[2].offsetWidth;
        var doneTextWidth = this.btnRef.current.childNodes[3].offsetWidth;
        var textUsed = loadingTextWidth > doneTextWidth ? loadingTextWidth : doneTextWidth;
        var sizeAdjustment = btnLength - spinnerWidth - (btnLength - textUsed) / 2;

        if (loadingTextWidth > sizeAdjustment || doneTextWidth > sizeAdjustment) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      this.setState({
        step: "loading",
        hideLoadingText: this.hideLoadingText()
      });
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      this.setState({
        step: "done"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var size = "btn-" + this.props.size;
      var shapeStyle = "btn-" + this.props.shapeStyle;
      var radius = "btn-" + this.props.radius;
      var step = "state-" + this.state.step;
      var iconPosition = "icon-" + this.props.iconPosition;
      var btnCss = (0, _classnames["default"])(radius, shapeStyle, size, this.props.colorTheme, step, iconPosition, {
        "btn-animated-loading": this.props.animated,
        "disabled": this.props.disabled,
        "fileUploader": this.props.type === "file",
        "noText": this.props.noText,
        "noLoadingText": this.state.hideLoadingText
      }, this.props.className);
      var spinnerClass = "spinner-" + this.state.step;
      var spinnerCss = (0, _classnames["default"])("spinner-progress", spinnerClass);
      var checkCss = (0, _classnames["default"])("checkmark", {
        "draw": this.state.step === "done"
      });

      var style = _objectSpread({}, this.props.style);

      if (this.props.animated) {
        if (this.props.type === "file") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            onClick: this.handleClickEvent,
            style: style,
            className: "btn ".concat(btnCss),
            tabIndex: this.props.tabIndex,
            onKeyDown: function onKeyDown(event) {
              var key = _keyDownHandler["default"].getKeysFromEvent(event);

              if (key === _keyDownHandler["default"].keys.enter) {
                _this3.btnRef.current.click();
              }
            }
          }, /*#__PURE__*/_react["default"].createElement("input", {
            ref: this.btnRef,
            type: "file",
            onChange: this.onChange,
            accept: this.props.fileAccept
          }), /*#__PURE__*/_react["default"].createElement("span", {
            className: "hide"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption loading"
          }, this.props.loadingText), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption done"
          }, this.props.doneText), /*#__PURE__*/_react["default"].createElement("div", {
            className: spinnerCss
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            version: "1.1",
            viewBox: "0 0 45 45",
            preserveAspectRatio: "none"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            className: "inner-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            className: "outer-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          })), /*#__PURE__*/_react["default"].createElement("svg", {
            className: checkCss,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 52 52"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
          }))));
        } else {
          return /*#__PURE__*/_react["default"].createElement("button", {
            ref: this.btnRef,
            formNoValidate: true,
            type: this.props.type,
            onClick: this.handleClickEvent,
            style: style,
            className: "btn ".concat(btnCss),
            tabIndex: this.props.tabIndex,
            disabled: this.props.disabled
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "hide"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption loading"
          }, this.props.loadingText), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption done"
          }, this.props.doneText), /*#__PURE__*/_react["default"].createElement("div", {
            className: spinnerCss
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            version: "1.1",
            viewBox: "0 0 45 45",
            preserveAspectRatio: "none"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            className: "inner-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            className: "outer-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          })), /*#__PURE__*/_react["default"].createElement("svg", {
            className: checkCss,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 52 52"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
          }))));
        }
      } else {
        if (this.props.type === "file") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: style,
            className: "btn ".concat(btnCss),
            onClick: function onClick(e) {
              _this3.props.onClick(e, _this3);
            },
            tabIndex: this.props.tabIndex,
            onKeyDown: function onKeyDown(event) {
              var key = _keyDownHandler["default"].getKeysFromEvent(event);

              if (key === _keyDownHandler["default"].keys.enter) {
                _this3.btnRef.current.click();
              }
            }
          }, /*#__PURE__*/_react["default"].createElement("p", null, this.props.text), /*#__PURE__*/_react["default"].createElement("input", {
            ref: this.btnRef,
            type: "file",
            onChange: this.onChange,
            disabled: this.props.disabled
          }));
        } else {
          return /*#__PURE__*/_react["default"].createElement("button", {
            formNoValidate: true,
            type: this.props.type,
            style: style,
            className: "btn ".concat(btnCss),
            onClick: function onClick(e) {
              _this3.props.onClick(e, _this3);
            },
            tabIndex: this.props.tabIndex,
            disabled: this.props.disabled
          }, this.props.text, this.props.children);
        }
      }
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  radius: _propTypes["default"].oneOf(["round", "square"]),
  shapeStyle: _propTypes["default"].oneOf(["fill", "stroke"]),
  size: _propTypes["default"].oneOf(["xsmall", "small", "medium", 'big']),
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  iconPosition: _propTypes["default"].oneOf(['right', 'left']),
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  animated: _propTypes["default"].bool,
  animateOnClick: _propTypes["default"].bool,
  loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  type: _propTypes["default"].oneOf(["button", "submit", 'reset', "file"]),
  tabIndex: _propTypes["default"].number,
  fileAccept: _propTypes["default"].string,
  noText: _propTypes["default"].bool
};
Button.defaultProps = {
  radius: "square",
  shapeStyle: "fill",
  size: "small",
  colorTheme: "teal",
  text: null,
  disabled: false,
  iconPosition: 'left',
  onClick: function onClick() {},
  onChange: function onChange() {},
  type: "button",
  tabIndex: 1,
  fileAccept: "",
  noText: false,
  className: "",
  style: {},
  animated: false,
  animateOnClick: true,
  loadingText: "Loading ...",
  doneText: "Done"
};
var _default = Button;
exports["default"] = _default;